/**
 * @generated SignedSource<<86f2a38c1037e661ab732568658855e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineOccasionAssignees_RoutineOccasion$data = {
  readonly assigned: ReadonlyArray<{
    readonly employee: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ToolbarButtonAssignees_employees">;
    } | null;
  }>;
  readonly assignedRoles: ReadonlyArray<{
    readonly role: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ToolbarButtonAssignees_roles">;
    };
  }>;
  readonly id: string;
  readonly " $fragmentType": "RoutineOccasionAssignees_RoutineOccasion";
};
export type RoutineOccasionAssignees_RoutineOccasion$key = {
  readonly " $data"?: RoutineOccasionAssignees_RoutineOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionAssignees_RoutineOccasion">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineOccasionAssignees_RoutineOccasion",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignedEmployee",
      "kind": "LinkedField",
      "name": "assigned",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "employee",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ToolbarButtonAssignees_employees"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignedRole",
      "kind": "LinkedField",
      "name": "assignedRoles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmployeeRole",
          "kind": "LinkedField",
          "name": "role",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ToolbarButtonAssignees_roles"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RoutineOccasion",
  "abstractKey": null
};
})();

(node as any).hash = "ea3bb1a039c49ac0ef2346b4031b6e37";

export default node;
